/**
 * Type predicate that narrows `T | null | undefined` to `T` and rejects
 * empty / whitespace-only strings. Use for "does this optional field have a
 * displayable value?" checks. Returns `true` for `false`, `0`, and empty
 * arrays — only `null`, `undefined`, and strings that trim to `''` are
 * treated as absent.
 */
export function hasValue<T>(value: T | null | undefined): value is T {
  if (value === null || value === undefined) {
    return false;
  }
  if (typeof value === 'string') {
    return value.trim() !== '';
  }
  return true;
}
